<template>
    <div style="padding:0 10px">
        <component :is="component" />
    </div>
</template>

<script>
    import Vue from 'vue'
    import dynamicPage from './dynamicPage'
    export default {
        name: 'NormalDetail',
        data() {
            return {
                component: null,
            }
        },
        mounted() {
            this.init()
        },
        beforeRouteUpdate(to, from, next) {
            next()
            this.init()
        },
        methods: {
            init() {
                const {
                    mixin,
                } = require(`@/config/${process.env.VUE_APP_PROJECT}/normalDetail/${this.$route.query.type}`)
                const component = Vue.extend({
                    ...dynamicPage,
                    mixins: [
                        mixin,
                        {
                            created() {
                                this.getData()
                            },
                        },
                    ],
                })
                this.component = component
            },
        },
    }
</script>

<style>
</style>
